import { createQueryParams } from '@nexio/emvio-util-app';

import config from '../../config/config';
import { goToUrl } from '../Table/tableActions';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const WEBHOOKS_FAILURE = 'WEBHOOKS/WEBHOOKS_FAILURE';
export const WEBHOOKS_LOAD = 'WEBHOOKS/WEBHOOKS_LOAD';
export const WEBHOOKS_SUCCESS = 'WEBHOOKS/WEBHOOKS_SUCCESS';

export const WEBHOOK_LOG_FAILURE = 'WEBHOOKLOG/WEBHOOK_LOG_FAILURE';
export const WEBHOOK_LOG_LOAD = 'WEBHOOKLOG/WEBHOOK_LOG_LOAD';
export const WEBHOOK_LOG_SUCCESS = 'WEBHOOKLOG/WEBHOOK_LOG_SUCCESS';

export const WEBHOOK_RESEND_FAILURE = 'WEBHOOKLOG/WEBHOOK_RESEND_FAILURE';
export const WEBHOOK_RESEND_LOAD = 'WEBHOOKLOG/WEBHOOK_RESEND_LOAD';
export const WEBHOOK_RESEND_SUCCESS = 'WEBHOOKLOG/WEBHOOK_RESEND_SUCCESS';

export function selectWebhook(history, webhookLog, newTab) {
    goToUrl(history, `/webhook/${webhookLog.logId}`, newTab);
}

export function getWebhookLog(logId) {
    return {
        failureActionTypeOrCreator: getWebhookLogFailureActionCreator,
        fetchParams: {
            url: `${config.webhookApiUrl}/${logId}`
        },
        loadActionTypeOrCreator: WEBHOOK_LOG_LOAD,
        successActionTypeOrCreator: getWebhookLogSuccessActionCreator
    };
}

export function getWebhookLogFailureActionCreator(error) {
    return {
        error,
        type: WEBHOOK_LOG_FAILURE
    };
}

export function getWebhookLogSuccessActionCreator(data) {
    return {
        data,
        type: WEBHOOK_LOG_SUCCESS
    };
}

export function resendWebhookLogs(webhooks) {
    return {
        failureActionTypeOrCreator: getWebhookResendFailureActionCreator,
        fetchParams: {
            body: { webhooks },
            url: `${config.webhookApiUrl}/resend`,
            method: 'POST'
        },
        loadActionTypeOrCreator: WEBHOOK_RESEND_LOAD,
        successActionTypeOrCreator: getWebhookResendSuccessActionCreator
    };
}

export function getWebhookResendFailureActionCreator(error) {
    return {
        error,
        type: WEBHOOK_RESEND_FAILURE
    };
}

export function getWebhookResendSuccessActionCreator() {
    return {
        data: true,
        type: WEBHOOK_RESEND_SUCCESS
    };
}

export function fetchWebhooks(filters, page, pageSize, sorters, merchantIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'webhookDate',
        merchantIds,
        filters,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: fetchWebhooksFailureActionCreator,
        fetchParams: {
            url: `${config.webhookApiUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: WEBHOOKS_LOAD,
        successActionTypeOrCreator: fetchWebhooksSuccessActionCreator
    };
}

export function fetchWebhooksFailureActionCreator(error) {
    return {
        error,
        type: WEBHOOKS_FAILURE
    };
}

export function fetchWebhooksSuccessActionCreator(results) {
    const data = buildTableSuccessActionBasedOnCount(results, WEBHOOKS_SUCCESS, 'rows');

    return { data, type: WEBHOOKS_SUCCESS };
}
